

export const BetaTag = () => {
    return <span className="text-xs text-indigo-500">BETA</span>
}